import { inject as i } from "vue";
const e = Symbol("dsConfig");
function r(t, o) {
  return t.provide(e, {
    listItemNext: o.listItemNext || !1
  });
}
function f() {
  return i(e, {});
}
export {
  e as configKey,
  r as createConfigProvider,
  f as useConfig
};
//# sourceMappingURL=design-system.es28.js.map
